import XMLHistory from './XMLHistory';
export default XMLHistory;



// WEBPACK FOOTER //
// ./src/pages/OrdersHistoryPage/components/ListOrders/components/ListOrders/components/XMLHistory/index.ts